import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight, FiActivity, FiWind, FiTarget, FiHeart, FiZap } = FiIcons;
const programs = [
  { number: '01', name: 'Strength', detail: 'Build strength that shows up in every part of your life.', icon: FiActivity, tag: 'LIFT WITH PURPOSE' },
  { number: '02', name: 'Conditioning', detail: 'Find your engine. Leave with more energy than you came in with.', icon: FiWind, tag: 'MOVE WITH INTENTION' },
  { number: '03', name: 'Personal training', detail: 'A plan that gets you where you want to go, one session at a time.', icon: FiTarget, tag: 'MADE FOR YOU' },
  { number: '04', name: 'Mobility', detail: 'Move better, recover faster, and stay in the game for the long run.', icon: FiHeart, tag: 'RECOVER WELL' },
  { number: '05', name: 'HIIT', detail: 'High-intensity intervals that burn bright and keep working after.', icon: FiZap, tag: 'BURN BRIGHT' },
  { number: '06', name: 'Group classes', detail: 'Train alongside people who push you to show up and go further.', icon: FiActivity, tag: 'STRONGER TOGETHER' },
];

function Programs() {
  return (
    <section className="programs-section" id="programs">
      <div className="section-head">
        <div>
          <span className="eyebrow">Find your kind of strong</span>
          <h2>Good training.<br /><em>On your terms.</em></h2>
        </div>
        <p>Whether you're building a new habit or chasing a new personal best, there's a place for you on the floor.</p>
      </div>
      <div className="program-grid">
        {programs.map((program, index) => (
          <motion.a
            href={waLink(`I am interested in the ${program.name} program.`)}
            target="_blank"
            rel="noreferrer"
            className="program-card"
            key={program.number}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ delay: (index % 3) * 0.1, duration: 0.45 }}
          >
            <div className="program-top"><span>{program.number} / 06</span><SafeIcon icon={FiArrowUpRight} /></div>
            <div className="program-icon"><SafeIcon icon={program.icon} /></div>
            <span className="program-tag">{program.tag}</span>
            <h3>{program.name}</h3>
            <p>{program.detail}</p>
            <span className="program-bottom">Explore training <SafeIcon icon={FiArrowUpRight} /></span>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
export default Programs;
